// extracted by mini-css-extract-plugin
export default {"loading":"ZYMg5KRu31HlCLtkPTdM","text":"iv5Caw10zyYWwQEdWYQA","bg":"urpnmSmq77FkLaV28aO6","MOVE-BG":"UUrMde3uV6VvgZPwWYxU","moveBg":"UUrMde3uV6VvgZPwWYxU"};